SideLayout.$inject = ['mx.shell.EventService'];

/**
 * @ngdoc service
 * @name mx.shell.SideLayout
 * @module mx.shell
 *
 * @property keepClosed {boolean} - a flag that controls visibility and showing behaviour of {@ref mx.shell:mxSidePanel side panel}.
 *        If `true' then `SidePanel` will not be opened in any case (change selection, add new `View`, ... ).
 *        This is kind of "pin" functionality.
 * @property {boolean} visible - Reflect visibility of {@ref mx.shell:mxSideLayout Side Layout}.<br>
 * @property {boolean} fullScreenMode - defines if a full screen mode is enabled.
 * If true - then {@ref mx.shell:mxSideLayout Side Layout} is opened, and closed otherwise
 * @description
 * Just controls visibility of Side Layout panel
 */
export function SideLayout(eventService) {
	var self = {
		keepClosed: false,
		visible: false,
		fullScreenMode: false,
		show: show,
		hide: hide,
		switchFullScreenMode: switchFullScreenMode,
	};

	var _debouncedLayoutChangeDispatcher = $.debounce(500, function () {
		eventService.dispatchEvent(mx.shell.EventCodes.LayoutChanged, 'sideLayoutResized');
	});

	return self;

	/**
	 * @ngdoc method
	 * @name mx.shell.SideLayout#show
	 *
	 * @description
	 * Shows {@ref mx.shell:mxSideLayout Side Layout}
	 */
	function show() {
		if (!self.visible) {
			self.visible = true;
			eventService.dispatchEvent(mx.shell.EventCodes.SidePanelVisibility, true);
			_debouncedLayoutChangeDispatcher();
		}
	}

	/**
	 * @ngdoc method
	 * @name mx.shell.SideLayout#hide
	 *
	 * @description
	 * Hides {@ref mx.shell:mxSideLayout Side Layout}
	 */
	function hide() {
		if (self.visible) {
			self.visible = false;
			eventService.dispatchEvent(mx.shell.EventCodes.SidePanelVisibility, false);
			_debouncedLayoutChangeDispatcher();
		}
	}

	/**
	 * @ngdoc method
	 * @name mx.shell.SideLayout#switchFullScreenMode
	 *
	 * @description
	 * Switches Full Screen Mode
	 * @param {boolean} isEnabled - defines if Full Screen Mode should be enabled or disabled. If not passed then flag will be changed to opposite.
	 */
	function switchFullScreenMode(isEnabled) {
		var fullScreenMode = typeof isEnabled === 'undefined' ? !self.fullScreenMode : Boolean(isEnabled);

		if (self.fullScreenMode !== fullScreenMode) {
			self.fullScreenMode = fullScreenMode;
			eventService.dispatchEvent(mx.shell.EventCodes.SideLayoutWideModeSwitched, self.fullScreenMode);
			_debouncedLayoutChangeDispatcher();
		}

		return self.fullScreenMode;
	}
}
